export default "__VITE_ASSET__1c855161__"